import { render, staticRenderFns } from "./PurD.vue?vue&type=template&id=78756ba9"
import script from "./PurD.vue?vue&type=script&lang=js"
export * from "./PurD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports